import { render, staticRenderFns } from "./AttachmentDownloader.vue?vue&type=template&id=72c7fd8c&scoped=true&"
import script from "./AttachmentDownloader.vue?vue&type=script&lang=js&"
export * from "./AttachmentDownloader.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentDownloader.vue?vue&type=style&index=0&id=72c7fd8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c7fd8c",
  null
  
)

export default component.exports